_ = require 'underscore'
$ = require 'jquery'
Auth = require 'db/auth'
BoardListAnnouncementComponent = require 'views/board-list/board-list-announcement-component'
BoardListItemAddComponent = require 'views/board-list/board-list-item-add-component'
BoardListItemComponent = require 'views/board-list/board-list-item-component'
BoardListItemDndComponent = require 'views/board-list/board-list-item-dnd-component'
BoardListSectionComponent = require 'views/board-list/board-list-section-component'
BoardListSectionDndComponent = require 'views/board-list/board-list-section-dnd-component'
BoardListSectionHeaderComponent = require 'views/board-list/board-list-section-header-component'
BoardListSectionHeaderLinkComponent = require 'views/board-list/board-list-section-header-link-component'
BoardsPageAddOrgButtonComponent = require 'views/member/boards-page-add-org-button-component'

HomeContainer = require 'views/home/home-container'

BoardsPageAnnouncement = require 'data/boards-page-announcement'
Controller = require 'controller'
CreateBoardComponent = require 'views/board-create/create-board-component'
CreateOrgView = require 'views/organization/create-org-view'
Dates = require 'lib/dates'
f = require 'effing'
l = require 'lib/localize'
createBoardHelpers = require 'views/board-create/helpers'
GoldBannerView = require 'views/member/gold-banner-view'
LastOrganization = require 'lib/last-organization'
TeamBannerView = require 'views/member/team-banner-view'
Dialog = require 'views/lib/dialog'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
recup = require 'recup'
getExperiment = require 'lib/experiments/simple-test'
{ maybeDisplayMemberLimitsError } = require 'views/board-menu/member-limits-error'
templates = require 'views/internal/templates'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
View = require 'view'
ModelCache = require 'db/model-cache'
ninvoke = require 'lib/util/ninvoke'
getTeamBanner = require 'lib/util/get-team-banner'
getGoldBanner = require 'lib/util/get-gold-banner'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
startDecayingInterval = require 'lib/util/decaying-interval'

module.exports = class MemberBoardsView extends View

  initialize: ->
    @listenTo @model.organizationList, 'add remove reset change:memberships',
      @frameDebounce @renderBanner

    @listenTo @model.organizationList, 'add remove reset change:name change:displayName change:logoHash change:products',
      @frameDebounce @renderReactSection

    @listenTo @model.boardList,
      'add remove reset change:name change:idOrganization change:dateLastActivity change:dateLastView',
      @frameDebounce @renderReactSection

    @listenTo @model.boardStarList, 'add remove reset change:pos',
      @renderReactSection

    @listenTo @model, 'change:oneTimeMessagesDismissed', @renderReactSection
    @listenTo @model, 'change:oneTimeMessagesDismissed', @renderBanner

    @loadSuperHomeCovert()
    # Twice often as the default intervals.
    @superHomeCovertInterval = startDecayingInterval(@loadSuperHomeCovert, {
      resetAfterMouseMove: true
      intervals: [
        {
          iterations: 6
          timeout: Util.getMs(seconds: 5)
        }
        {
          iterations: 10
          timeout: Util.getMs(seconds: 30)
        }
      ]
    })

  loadSuperHomeCovert: ->
    ModelLoader.loadUpNextCovert()
    ModelLoader.loadHighlightsCovert()

  className: 'member-boards-view'

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      @getMemberBoardsElements()

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  renderBanner: ->
    $banners = @$('.js-boards-page-banners').empty()

    {
      bannerToDisplay
      idBannersToDismiss
    } = getTeamBanner(@model)

    goldBanner = getGoldBanner(@model)

    if bannerToDisplay
      if goldBanner && !bannerToDisplay.doesIncludeGold
        $banners.prepend(@subview(GoldBannerView, @model, { banner: goldBanner, idTeamBannersToDismiss: idBannersToDismiss }).render().el)
      else
        $banners.prepend(new TeamBannerView({ bannerToDisplay, idBannersToDismiss, @model }).render().el)
        track('Boards Page', 'Team Banner Displayed', bannerToDisplay.type)
        trackUe('Boards Page', 'display', 'team banner', '', 'to a user',  '', bannerToDisplay.type)
    else if goldBanner
      $banners.prepend(@subview(GoldBannerView, @model, { banner: goldBanner }).render().el)

  render: ->
    @$el.html('<div class="js-boards-page-banners"></div><div class="js-boards-page"></div>')
    @$reactRoot ?= @$('.js-boards-page')
    @orgname = @options.orgname
    @renderReactSection()
    @renderBanner()

    @

  getMemberBoardsElements: ->
    # TODO: When we add the sidebar with Homecoming, we should get rid
    # noSidebarMod (see also
    # views/board-list/board-list-section-component.coffee and
    # boards-page-board-section.less).

    recup.render => recup.div =>
      showAnnouncement =
        BoardsPageAnnouncement?.enabled &&
        !@model.isDismissed(BoardsPageAnnouncement.id) &&
        window.locale == BoardsPageAnnouncement.locale &&
        Date.now() < Dates.parse(BoardsPageAnnouncement.dateExpires)

      if showAnnouncement
        if !@_recordedDisplayed
          @_recordedDisplayed = true
          track("Boards Page Announcement", "Displayed", BoardsPageAnnouncement.id)
        recup.createElement BoardListAnnouncementComponent, {
          icon: BoardsPageAnnouncement.icon
          message: BoardsPageAnnouncement.message
          onClick: (e) =>
            if e.target.href?
              track("Boards Page Announcement", "Click", BoardsPageAnnouncement.id, e.target.href)
          onDismiss: (message) =>
            @model.dismiss(BoardsPageAnnouncement.id)
            track("Boards Page Announcement", "Dismiss", BoardsPageAnnouncement.id)
        }

      if getExperiment('superHome')?.get('enabled')
        recup.createElement HomeContainer, {
          modelCache: @modelCache
          model: @model
          orgname: @orgname
        }

      else
        props =
          items: @getStarredBoards().map((board) =>
            @boardToBoardItemDndElement(board, 'Starred Boards'))
          header: @getStarredBoardsHeader()
          noSidebarMod: true
        if props.items.length > 0
          recup.createElement BoardListSectionDndComponent, props

        props =
          items: @getMyBoards().map((board) =>
            @boardToBoardItemElement(board, 'Personal Boards'))
          header: @getMyBoardsHeader()
          mayBeSorted: true
          noSidebarMod: true
          createNewItem: React.createElement BoardListItemAddComponent,
            preloadData: f(@, 'preloadCreateBoardData')
            newBoard: f(@, 'newBoard', @model)

        recup.createElement BoardListSectionComponent, props

        for org in @model.getSortedOrgs()
          props =
            items: @getOrgBoards(org).map((board) =>
              @boardToBoardItemElement(board, 'Team Boards'))
            header: @getOrgHeader(org)
            mayBeSorted: true
            noSidebarMod: true
            createNewItem: React.createElement BoardListItemAddComponent,
              preloadData: f(@, 'preloadCreateBoardData')
              newBoard: f(@, 'newBoard', org)
            orgId: org.id
            orgName: org.get('name')
          recup.createElement BoardListSectionComponent, props

        recup.addElement @getAddOrgButtonElement()

  backgroundObjForBoard: (board) ->
    _.extend brightness: board.getPref('backgroundBrightness'),
      if board.getPref('backgroundTile')
        image: board.getPref('backgroundImage')
        tiled: true
      else if preview = Util.smallestPreviewBiggerThan(board.getPref('backgroundImageScaled'), 400, 200)?.url ? board.getPref('backgroundImage')
        image: preview
        tiled: false
      else
        color: board.getPref('backgroundColor') ? board.getClientBackgroundColor('blue')

  boardToBoardItemDndElement: (board, sectionName) ->
    props = @boardToBoardItemProps(board, sectionName)
    props.onDragHover = (idBoardHoverer) =>
      boardStarList = Auth.me().boardStarList
      boardStar = boardStarList.getBoardStar(idBoardHoverer)
      index = boardStarList.getBoardIndex(board.id)
      pos = boardStarList.getNewPos(boardStar, index)
      boardStar.set({ pos })
    props.onDragEnd = ->
      boardStarList = Auth.me().boardStarList
      boardStar = boardStarList.getBoardStar(board.id)
      Promise.using ModelCache.getLock(), ->
        ninvoke boardStar, 'update', (pos: boardStar.get('pos'))
        .catch ->
      .done()
      return
    props.orgname = board.getOrganization()?.get('displayName')
    props.isDraggable = true

    React.createElement BoardListItemDndComponent, props

  boardToBoardItemElement: (board, sectionName) ->
    React.createElement BoardListItemComponent,
      @boardToBoardItemProps(board, sectionName)

  boardToBoardItemProps: (board, sectionName) ->
    id: board.id
    name: board.get('name')
    hasUnseenActivity: board.hasUnseenActivity()
    dateLastActivity: new Date(board.get('dateLastActivity') ? Util.idToDate(board.id))
    isLessActive: board.isLessActive()
    background: @backgroundObjForBoard(board)
    showOptions: Auth.isLoggedIn()
    isStarred: Auth.me().boardStarList.getBoardStar(board.id)?
    relUrl: board.getUrl()
    onStarClick: (idBoard) =>
      boardStarList = Auth.me().boardStarList
      Promise.using ModelCache.getLock(), ->
        if !boardStarList.getBoardStar(idBoard)?
          boardStarList.starBoard(idBoard)
          track('Boards View', 'Star Board', sectionName)
        else
          boardStarList.unstarBoard(idBoard)
          track('Boards View', 'Unstar Board', sectionName)
      .done()
      return
    badgeComponents: []
    tagComponents: []
    key: board.id
    onBoardClick: ->
      track('Boards View', 'Click on Board', sectionName)

  preloadCreateBoardData: ->
    createBoardHelpers.preloadData()

  newBoard: (model, el) ->
    if maybeDisplayMemberLimitsError($(el), null, Auth.me())
      return

    Dialog.show
      displayType: 'mod-no-chrome'
      opacity: 0.75
      reactElement: React.createElement CreateBoardComponent,
        defaultOrg: if model.typeName == 'Organization' then model else LastOrganization.NO_ORGANIZATION

    track("Boards View", "Clicked 'Create new board' Button")
    return

  getAddOrgButtonElement: ->
    props =
      onClick: f(@, 'showAddOrgPopOver')

    React.createElement BoardsPageAddOrgButtonComponent, props

  showAddOrgPopOver: (el) ->
    track("Boards View", "Clicked Add Org Button")
    PopOver.toggle
      elem: el
      top: 0
      view: CreateOrgView
      options: { @model, @modelCache }

  getMyBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('board section title.personal boards')
      iconClass: 'member'
    }

  getMyBoards: ->
    _.filter @model.boardList.models, (board) -> !board.isOrgBoard() && board.isOpen()

  getOrgHeader: (org) ->
    props =
      title: org.get('displayName')
      iconClass: 'organization'
      logoHash: org.get('logoHash')
      linkElements: [
        {
          url: Controller.getOrganizationUrl(org),
          iconClass: 'board',
          titleKey: 'boards',
          onClick: ->
            track 'Boards View', 'Clicked Team Boards Button'
        },
        {
          url: Controller.getOrganizationMembersUrl(org),
          iconClass: 'member',
          titleKey: 'members',
          onClick: ->
            track 'Boards View', 'Clicked Team Members Button'
        },
        {
          url: Controller.getOrganizationAccountUrl(org),
          iconClass: 'gear',
          titleKey: 'settings',
          onClick: ->
            track 'Boards View', 'Clicked Team Settings Button'
        }
      ].map(f.choke(1, React, 'createElement', BoardListSectionHeaderLinkComponent))

    if org.isFeatureEnabled('enterpriseUI')
      props.smallIconClass = 'enterprise'
      props.smallIconTitleKey = 'enterprise'
    else if org.isPremium()
      props.smallIconClass = 'business-class'
      props.smallIconTitleKey = 'business-class'

    React.createElement BoardListSectionHeaderComponent, props

  getOrgBoards: (org) ->
    _.filter @model.boardList.models, (board) =>
      board.getOrganization()?.id == org.id &&
      board.isOpen()

  getStarredBoardsHeader: ->
    React.createElement BoardListSectionHeaderComponent, {
      title: l('board section title.starred boards')
      iconClass: 'star'
    }

  getStarredBoards: ->
     _.filter @model.boardStarList.getBoards(), (board) ->
      board.isOpen()

  remove: ->
    @superHomeCovertInterval?()
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-boards-view.coffee